import { createAction, createReducer } from "@reduxjs/toolkit";

// Types
import { PaginationParams, ParamsList } from "../../../../../types";

// State
import { AppState } from "../../../../store";

// Helpers
import { DefaultPaginationLimit } from "../../../../../consts";

interface ViewsAdminUsersTableState {
  params: Required<ParamsList>;
}

export const setParamsPagination = createAction<PaginationParams>(
  "views/admin/users/table/params/pagination/set"
);

export const setParamsPaginationToken = createAction<string>(
  "views/admin/users/table/params/pagination/token/set"
);

export const setParamsPaginationLimit = createAction<number>(
  "views/admin/users/table/params/pagination/limit/set"
);

export const setParamsFilter = createAction<string>(
  "views/admin/users/table/params/filter/set"
);

export const viewsAdminUsersTableInitialState: ViewsAdminUsersTableState = {
  params: {
    token: "",
    limit: DefaultPaginationLimit,
    filter: "",
  },
};

export const viewsAdminUsersTableReducer = createReducer(
  viewsAdminUsersTableInitialState,
  (builder) => {
    builder
      .addCase(setParamsPagination, (state, { payload: { limit, token } }) => {
        state.params.limit = limit;
        state.params.token = token;
      })
      .addCase(setParamsPaginationToken, (state, { payload }) => {
        state.params.token = payload;
      })
      .addCase(setParamsPaginationLimit, (state, { payload }) => {
        state.params.token = undefined;
        state.params.limit = payload;
      })
      .addCase(setParamsFilter, (state, { payload }) => {
        state.params.filter = payload;
      });
  }
);

export const selectTableParams = (state: AppState): Required<ParamsList> =>
  state.views.admin.users.table.params;

export const selectTableParamsPagination = (
  state: AppState
): PaginationParams => {
  const { limit, token } = selectTableParams(state);

  return { limit, token };
};
